// extracted by mini-css-extract-plugin
module.exports = {"container":"MainNavigation_container__XjfnF"};